import styled from 'styled-components';

const ToolFieldsGrid = styled.div`
  display: grid;
  gap: 40px;
  grid-template-columns: 1fr;

  ${(props) => props.theme.media.tablet} {
    grid-template-columns: repeat(2, minmax(0, 1fr));

    & .w-full {
      grid-column: span 2;
    }
  }
`;
export default ToolFieldsGrid;
